import { Box, Button, Typography } from "@material-ui/core";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const { text } = themeColorsDesingSystem;

export default function SectionHeader({ title, onVerTodos }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginBottom={2}
    >
      <Typography variant="h2" style={{ color: text.primary, fontWeight: 700 }}>
        {title}
      </Typography>
      {onVerTodos && (
        <Button
          color="primary"
          size="medium"
          onClick={onVerTodos}
          style={{ fontWeight: 600, textTransform: "none" }}
        >
          Ver todos
        </Button>
      )}
    </Box>
  );
}
